import axios from '@/axios-api.js';
import Notify from '@/components/Notification';
import { FILE_FORMATS_BY_CONTENT_TYPE } from '@/helpers/files';

export const useDownloadLink = () => {
  const getFilenameFromContentDisposition = header => {
    if (!header) return null;
    const match = header.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/i);
    return match ? decodeURIComponent(match[1]) : null;
  };

  const onDownload = async ({ url, filename }) => {
    const response = await axios.get(url, {
      responseType: 'blob',
    });

    if (response?.status === 200) {
      const contentType = response.headers['content-type'] || '';
      const contentDisposition = response.headers.get('content-disposition');
      const fileNameByContentDisposition = getFilenameFromContentDisposition(contentDisposition);
      const href = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = href;
      const format = `.${FILE_FORMATS_BY_CONTENT_TYPE[contentType] || 'pdf'}`;
      const fileName = fileNameByContentDisposition || filename + format;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    } else {
      Notify.error({ text: 'Download file failed' });
    }
  };

  return { onDownload };
};
